export default __webpack_public_path__ + "static/media/maximum_bet_50$.46f154ca.mp3";